import { GridContentsColumnContextProvider } from './GridContentsColumnContext';

export const GridContentsColumn = ({
  columnIndex,
  className,
  style,
  children,
  itemsClassName
}) => {
  return (
    <GridContentsColumnContextProvider
      key={`renderKey-${columnIndex}`}
      columnIndex={columnIndex}
      itemsClassName={itemsClassName}
    >
      <div
        className={`contents ${className}`}
        style={{
          ...(style ?? {})
        }}
      >
        { children }
      </div>
    </GridContentsColumnContextProvider>
  );
};
